import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import { styles } from './styled-button';

const StyledLink = styled(Link).attrs({
  className: 'btn btn-primary btn-sm',
})``;

export default StyledLink;
